import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { CompanyPage } from './pages/CompanyPage'
import { EventsPage } from './pages/EventsPage'
import { ProspectsPage } from './pages/ProspectsPage'

export default function App() {
  return <Routes><Route element={<AppShell />}>
    <Route index element={<Navigate to="/enseignes" replace />} />
    <Route path="enseignes" element={<ProspectsPage />} />
    <Route path="contacts" element={<ProspectsPage />} />
    <Route path="companies/:companyId" element={<CompanyPage />} />
    <Route path="events" element={<EventsPage />} />
    <Route path="*" element={<Navigate to="/enseignes" replace />} />
  </Route></Routes>
}
